
const state = () => ({

  _callstack: [],

  screed: { values: [] },

  insulation: { values: [] },

  underfloorHeating: { values: [] },

  stand: { values: [] },

  compartmentInsulation: { values: [] },

  soundInsulation: { values: [] },

  woodenPanel: { values: [] },

  pinsulation: { values: [] },

  suspendedCeiling: { values: [] },

  render: { values: [] },

  outerPlanking: { values: [] },

  innerPlanking1: { values: [] },

  innerPlanking2: { values: [] },

  innerPlanking3: { values: [] },

  impactSoundLevel: { values: [] },

  soundReductionIndex: { values: [] },

  heatTransferCoefficient: { values: [] },

  fireResistanceInner: { values: [] },

  fireResistanceOuter: { values: [] },

  fireBehavior: { values: [] }

})

export default state
